var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PanelHeading',{attrs:{"title":_vm.currentSite.address,"subtitle":_vm.title,"description":_vm.description,"header":"","headerColor":"gray","wave":""},scopedSlots:_vm._u([(_vm.hasDescriptionSlot)?{key:"description",fn:function(){return [_vm._t("description")]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }